import { render, staticRenderFns } from "./CrudStepsNavBar.vue?vue&type=template&id=451e552c&"
import script from "./CrudStepsNavBar.vue?vue&type=script&lang=ts&"
export * from "./CrudStepsNavBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('451e552c', component.options)
    } else {
      api.reload('451e552c', component.options)
    }
    module.hot.accept("./CrudStepsNavBar.vue?vue&type=template&id=451e552c&", function () {
      api.rerender('451e552c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/CrudStepsNavBar.vue"
export default component.exports